import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  IconButton,
  Fade,
  Grow,
  Button,
} from "@mui/material";
import styles, { pageScrollStyle } from "../../../styles/styles";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import SecurityRoundedIcon from "@mui/icons-material/SecurityRounded";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import BusinessRoundedIcon from "@mui/icons-material/BusinessRounded";
import GroupRoundedIcon from "@mui/icons-material/GroupRounded";
import CreditCardRoundedIcon from "@mui/icons-material/CreditCardRounded";
import PaletteRoundedIcon from "@mui/icons-material/PaletteRounded";
import LanguageRoundedIcon from "@mui/icons-material/LanguageRounded";
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import ExtensionRoundedIcon from "@mui/icons-material/ExtensionRounded";
import VpnKeyRoundedIcon from "@mui/icons-material/VpnKeyRounded";
import AdminPanelSettingsRoundedIcon from "@mui/icons-material/AdminPanelSettingsRounded";
import ListAltRoundedIcon from "@mui/icons-material/ListAltRounded";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import FolderRoundedIcon from "@mui/icons-material/FolderRounded";
import CategoryRoundedIcon from "@mui/icons-material/CategoryRounded";
import PaymentRoundedIcon from "@mui/icons-material/PaymentRounded";
import AutorenewRoundedIcon from "@mui/icons-material/AutorenewRounded";
import ThumbsUpDownRoundedIcon from "@mui/icons-material/ThumbsUpDownRounded";
import ReceiptRoundedIcon from "@mui/icons-material/ReceiptRounded";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import ViewKanbanRoundedIcon from "@mui/icons-material/ViewKanbanRounded";
import { motion } from "framer-motion";
import FormModules from "../../../components/LawyerCompo/Settings/FormModules";
import { useNavigate, useLocation } from "react-router-dom";
import TeamPage from "../TeamMembers/TeamPage";
import GroupAddRoundedIcon from "@mui/icons-material/GroupAddRounded";
import { useDialog } from "../../../components/DialogContext";
import InviteUserForm from "../TeamMembers/Users Form/InviteUserForm";

export const allSettings = [
  {
    category: "Account Settings",
    items: [
      {
        title: "Profile Information",
        description: "Update your name, email, and profile picture.",
        icon: <PersonRoundedIcon />,
        path: "profile",
        component: () => <div>Profile Information Settings Component</div>,
      },
      {
        title: "Change Password",
        description: "Update or reset your password.",
        icon: <LockRoundedIcon />,
        path: "change-password",
        component: () => <div>Change Password Settings Component</div>,
      },
      {
        title: "Login Activity",
        description: "Review recent logins and active sessions.",
        icon: <HistoryRoundedIcon />,
        path: "login-activity",
        component: () => <div>Login Activity Settings Component</div>,
      },
    ],
  },
  {
    category: "Firm & Users",
    items: [
      {
        title: "Company Profile",
        description: "Manage your firm's details and logo.",
        icon: <BusinessRoundedIcon />,
        path: "company-profile",
        component: () => <div>Company Profile Settings Component</div>,
      },
      {
        title: "Users & Roles",
        description: "Manage team members and their permissions.",
        icon: <GroupRoundedIcon />,
        path: "users-roles",
        component: () => (
          <div>
            <TeamPage />
          </div>
        ),
      },
      {
        title: "Subscription & Billing",
        description: "View or modify your subscription plan.",
        icon: <CreditCardRoundedIcon />,
        path: "billing",
        component: () => <div>Subscription & Billing Settings Component</div>,
      },
      {
        title: "Language & Timezone",
        description: "Set your preferred language and timezone.",
        icon: <LanguageRoundedIcon />,
        path: "language",
        component: () => <div>Language & Timezone Settings Component</div>,
      },
      {
        title: "Email & Notifications",
        description: "Configure your email and notification preferences.",
        icon: <NotificationsRoundedIcon />,
        path: "notifications",
        component: () => <div>Email & Notifications Settings Component</div>,
      },
    ],
  },

  {
    category: "Security & Compliance",
    items: [
      // {
      //   title: "Access Control",
      //   description: "Set permissions and access levels for users.",
      //   icon: <AdminPanelSettingsRoundedIcon />,
      //   path: "access-control",
      //   component: () => <div>Access Control Settings Component</div>,
      // },
      {
        title: "Audit Logs",
        description: "Review logs of user activities and changes.",
        icon: <ListAltRoundedIcon />,
        path: "audit-logs",
        component: () => <div>Audit Logs Settings Component</div>,
      },
      {
        title: "Two-Factor Authentication",
        description: "Enable 2FA for enhanced security.",
        icon: <SecurityRoundedIcon />,
        path: "2fa",
        component: () => (
          <div>Two-Factor Authentication Settings Component</div>
        ),
      },
      // {
      //   title: "GDPR & Privacy",
      //   description: "Manage data privacy settings and compliance.",
      //   icon: <ShieldRoundedIcon />,
      //   path: "privacy",
      //   component: () => <div>GDPR & Privacy Settings Component</div>,
      // },
    ],
  },
  {
    category: "Billing & Payments",
    items: [
      {
        title: "Payment Gateways",
        description: "Configure and manage payment processors.",
        icon: <PaymentRoundedIcon />,
        path: "payment-gateways",
        component: () => <div>Payment Gateways Settings Component</div>,
      },
      {
        title: "Invoice Templates",
        description: "Customize invoice layouts and information.",
        icon: <ReceiptRoundedIcon />,
        path: "invoice-templates",
        component: () => <div>Invoice Templates Settings Component</div>,
      },
    ],
  },
  {
    category: "Customization",
    items: [
      {
        title: "Form Layout & Custom Fields",
        description: "Create and manage custom form templates.",
        icon: <ViewKanbanRoundedIcon />,
        path: "form-templates",
        component: () => (
          <>
            <FormModules />
          </>
        ),
      },
    ],
  },
  {
    category: "Integrations & API",
    items: [
      {
        title: "Connected Apps",
        description: "Manage third-party integrations.",
        icon: <ExtensionRoundedIcon />,
        path: "integrations",
        component: () => <div>Connected Apps Settings Component</div>,
      },
      {
        title: "API Keys & Webhooks",
        description: "Generate and manage API credentials.",
        icon: <VpnKeyRoundedIcon />,
        path: "api-keys",
        component: () => <div>API Keys & Webhooks Settings Component</div>,
      },
    ],
  },
  {
    category: "Automation",
    items: [
      {
        title: "Workflow Rules",
        description: "Automate tasks and processes.",
        icon: <AutorenewRoundedIcon />,
        path: "workflow-rules",
        component: () => <div>Workflow Rules Settings Component</div>,
      },
      {
        title: "Approval Processes",
        description: "Set up approval workflows for various actions.",
        icon: <ThumbsUpDownRoundedIcon />,
        path: "approval-processes",
        component: () => <div>Approval Processes Settings Component</div>,
      },
    ],
  },
];

// Helper function to find a setting by path
const findSettingByPath = (path) => {
  for (const section of allSettings) {
    for (const item of section.items) {
      if (item.path === path) {
        return { item, category: section.category };
      }
    }
  }
  return null;
};

const SettingPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { showDialog } = useDialog();
  const [showContent, setShowContent] = useState(true);
  const [pathAnimation, setPathAnimation] = useState(false);

  // Extract the current path from the URL
  // This will match paths like /dashboard/settings/profile
  const pathMatch = location.pathname.match(/\/dashboard\/settings\/(.+)$/);
  const currentPath = pathMatch ? pathMatch[1] : null;
  const currentSetting = currentPath ? findSettingByPath(currentPath) : null;

  // Set up effect to respond to URL changes
  useEffect(() => {
    setPathAnimation(true);
    const timer = setTimeout(() => {
      setPathAnimation(false);
    }, 500);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  // When a setting is clicked, update URL but stay on same page
  const handleSettingClick = (path) => {
    setShowContent(false);
    setTimeout(() => {
      // Update URL without navigating to a new page component
      navigate(`/dashboard/settings/${path}`, { replace: false });
      setTimeout(() => {
        setShowContent(true);
      }, 100);
    }, 300);
  };

  // Go back to main settings view
  const goBackToAllSettings = () => {
    navigate("/dashboard/settings", { replace: false });
  };

  const pathItemVariants = {
    hidden: { opacity: 0, y: -10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.3 },
    },
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        {/* Header with animated path */}
        <Box
          className=" bg-white rounded-lg shadow-md "
          sx={{
            p: "0.5rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "0.1rem",
              position: "relative",
            }}
          >
            <h3
              className={styles.title}
              style={{ cursor: "pointer" }}
              onClick={goBackToAllSettings}
            >
              Settings
            </h3>
            <KeyboardArrowRightRoundedIcon sx={{ fontSize: "1rem" }} />

            {currentSetting ? (
              <>
                <motion.div
                  initial="hidden"
                  animate="visible"
                  variants={pathItemVariants}
                  transition={{ delay: 0.2 }}
                >
                  <Typography
                    variant="body1"
                    sx={{ fontSize: "0.8rem", color: "text.secondary" }}
                  >
                    {currentSetting.category}
                  </Typography>
                </motion.div>

                <motion.div
                  initial="hidden"
                  animate="visible"
                  variants={pathItemVariants}
                  transition={{ delay: 0.3 }}
                >
                  <KeyboardArrowRightRoundedIcon sx={{ fontSize: "1rem" }} />
                </motion.div>

                <motion.div
                  initial="hidden"
                  animate="visible"
                  variants={pathItemVariants}
                  transition={{ delay: 0.4 }}
                >
                  <Typography
                    variant="body1"
                    sx={{ fontSize: "0.8rem", color: "primary.main" }}
                  >
                    {currentSetting.item.title}
                  </Typography>
                </motion.div>
              </>
            ) : (
              <Fade in={!pathAnimation} timeout={500}>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: "0.8rem",
                    color: "text.secondary",
                    cursor: "pointer",
                  }}
                >
                  All Settings
                </Typography>
              </Fade>
            )}
          </Box>
          <Box sx={{ display: "flex", gap: "1rem" }}>
            {location.pathname === "/dashboard/settings/users-roles" ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "1rem",
                  alignItems: "center",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  endIcon={<GroupAddRoundedIcon />}
                  onClick={() => {
                    showDialog(<InviteUserForm />, {
                      dialogTitle: "Invite User",
                    });
                  }}
                >
                  Invite User
                </Button>
                <Button variant="outlined" color="primary" size="small">
                  Transfer Ownership
                </Button>
              </Box>
            ) : null}
          </Box>
        </Box>

        {/* Content Area with transitions */}
        <Paper
          elevation={1}
          sx={{
            p: 3,
            borderRadius: 2,
            ...pageScrollStyle,
            overflow: "auto",
            maxHeight: "80vh",
          }}
        >
          <Fade in={showContent} timeout={500}>
            <Box>
              {currentSetting ? (
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mb: "0.9rem",
                      cursor: "pointer",
                    }}
                    onClick={goBackToAllSettings}
                  >
                    <IconButton
                      size="small"
                      sx={{
                        mr: 1,
                        transition: "transform 0.3s ease",
                        "&:hover": {
                          transform: "translateX(-3px)",
                        },
                      }}
                    >
                      <ArrowBackRoundedIcon />
                    </IconButton>
                    <Typography variant="body1">
                      Back to All Settings
                    </Typography>
                  </Box>

                  <Box sx={{ mb: 3 }}>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#EEEEED",
                          color: "primary.main",
                          borderRadius: "50%",
                          width: "3rem",
                          height: "3rem",
                          mr: 2,
                          p: 1,
                          transition:
                            "transform 0.3s ease, background-color 0.3s ease",
                          "&:hover": {
                            transform: "scale(1.05)",
                            backgroundColor: "#E6E6E5",
                          },
                        }}
                      >
                        {currentSetting.item.icon}
                      </Box>
                      <Box>
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                          {currentSetting.item.title}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ color: "text.secondary" }}
                        >
                          {currentSetting.item.description}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  <Grow in={true} timeout={800}>
                    <Box sx={{ mt: 2 }}>{currentSetting.item.component()}</Box>
                  </Grow>
                </motion.div>
              ) : (
                <Box>
                  {allSettings?.map((section, sectionIndex) => (
                    <motion.div
                      key={sectionIndex}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5, delay: sectionIndex * 0.1 }}
                    >
                      <Box sx={{ mb: "1rem" }}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: 600,
                            mb: "0.5rem",
                            color: "text.primary",
                          }}
                        >
                          {section.category}
                        </Typography>
                        <Grid container spacing={2}>
                          {section.items.map((item, itemIndex) => (
                            <Grid item xs={12} md={6} lg={4} key={itemIndex}>
                              <motion.div
                                initial={{ opacity: 0, scale: 0.95 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{
                                  duration: 0.3,
                                  delay: sectionIndex * 0.05 + itemIndex * 0.05,
                                }}
                                whileHover={{ scale: 1.02 }}
                              >
                                <Box
                                  sx={{
                                    p: "0.5rem",
                                    borderRadius: "0.5rem",
                                    border: "1px solid",
                                    borderColor: "divider",
                                    cursor: "pointer",
                                    transition: "all 0.3s ease",
                                    "&:hover": {
                                      boxShadow: 3,
                                      transform: "translateY(-3px)",
                                    },
                                  }}
                                  onClick={() => handleSettingClick(item.path)}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "flex-start",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        backgroundColor: "#EEEEED",
                                        color: "primary.main",
                                        borderRadius: "50%",
                                        width: "2.5rem",
                                        height: "2.5rem",
                                        mr: 2,
                                        p: 1,
                                        transition:
                                          "background-color 0.3s ease, transform 0.3s ease",
                                        "&:hover": {
                                          backgroundColor: "#E0E0E0",
                                          transform: "rotate(20deg)",
                                        },
                                      }}
                                    >
                                      {item?.icon}
                                    </Box>
                                    <Box sx={{ flexGrow: 1 }}>
                                      <Typography
                                        variant="body1"
                                        sx={{
                                          fontWeight: 500,
                                          mb: "0.1rem",
                                          color: "text.primary",
                                        }}
                                      >
                                        {item.title}
                                      </Typography>
                                      <Typography
                                        variant="body1"
                                        sx={{
                                          width: "15rem",
                                          overflow: "hidden",
                                          whiteSpace: "nowrap",
                                          fontSize: "0.8rem",
                                          color: "text.secondary",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        {item.description}
                                      </Typography>
                                    </Box>
                                    <ChevronRightRoundedIcon
                                      sx={{
                                        color: "#BDBDBD",
                                        transition: "transform 0.3s ease",
                                        ".MuiBox-root:hover &": {
                                          transform: "translateX(4px)",
                                          color: "primary.main",
                                        },
                                      }}
                                    />
                                  </Box>
                                </Box>
                              </motion.div>
                            </Grid>
                          ))}
                        </Grid>
                      </Box>
                    </motion.div>
                  ))}
                </Box>
              )}
            </Box>
          </Fade>
        </Paper>
      </Box>
    </Box>
  );
};

export default SettingPage;
